module.exports = __webpack_public_path__ + "img/pass_left.45bd425a.jpg";